module.exports = __webpack_public_path__ + "static/media/LCD-prosessi-pysty-fi.4532474a.svg";